"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderQuestion: function() {
        return FolderQuestion;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderQuestion = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V8C21 7.44772 20.5523 7 20 7H12.6056C12.0133 7 11.4343 6.82469 10.9415 6.49615L8.94915 5.16795C8.78488 5.05844 8.59187 5 8.39445 5H4ZM1 6C1 4.34315 2.34315 3 4 3H8.39445C8.98672 3 9.56575 3.17531 10.0585 3.50385L12.0509 4.83205C12.2151 4.94156 12.4081 5 12.6056 5H20C21.6569 5 23 6.34315 23 8V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6ZM11.937 10.25C11.4724 10.25 11.0795 10.5677 10.9684 10.9993C10.8308 11.5341 10.2856 11.8561 9.75074 11.7184C9.21589 11.5808 8.8939 11.0356 9.03156 10.5007C9.36454 9.20704 10.5377 8.25 11.937 8.25C13.5938 8.25 14.937 9.59315 14.937 11.25C14.937 12.1814 14.4825 12.7993 14.0065 13.2587C13.8136 13.4449 13.594 13.6269 13.3966 13.7905C13.3675 13.8146 13.3389 13.8383 13.3109 13.8616C13.0805 14.0533 12.86 14.2413 12.6441 14.4571C12.2536 14.8476 11.6204 14.8476 11.2299 14.4571C10.8394 14.0666 10.8394 13.4334 11.2299 13.0429C11.5141 12.7587 11.7936 12.5223 12.0319 12.324C12.0635 12.2978 12.0939 12.2725 12.1234 12.248C12.328 12.0782 12.4832 11.9494 12.6175 11.8197C12.8915 11.5553 12.937 11.4232 12.937 11.25C12.937 10.6977 12.4893 10.25 11.937 10.25ZM10.9375 16.25C10.9375 15.6977 11.3852 15.25 11.9375 15.25H11.9475C12.4998 15.25 12.9475 15.6977 12.9475 16.25C12.9475 16.8023 12.4998 17.25 11.9475 17.25H11.9375C11.3852 17.25 10.9375 16.8023 10.9375 16.25Z",
        fill: "currentColor"
    })
}), "FolderQuestion");
const _default = FolderQuestion;
